import React from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { Box } from "@mui/material";

export const Animation_Error_animation = ({ color }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        backgroundColor: "#FFF5F5",
        border: "3px solid #FED7D7",
        borderRadius: "50%",
        padding: "20px",
      }}
    >
      {/* Fondo de icono blanco */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80px",
          width: "80px",
          backgroundColor: "#FFFFFF",
          borderRadius: "50%",
        }}
      >
        <CancelOutlinedIcon sx={{ fontSize: 100, color: color }} />
      </Box>
    </Box>
  );
};

export default Animation_Error_animation;
